import { toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "fw-bold fs-5" }
const _hoisted_2 = {
  class: "progress my-3",
  style: {"width":"100%"}
}
const _hoisted_3 = ["aria-valuenow"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createTextVNode(_toDisplayString(_ctx.progressText) + " ", 1),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", {
        class: "progress-bar",
        role: "progressbar",
        style: _normalizeStyle({ width: _ctx.progress + '%' }),
        "aria-valuenow": _ctx.progress,
        "aria-valuemin": "0",
        "aria-valuemax": "100"
      }, null, 12, _hoisted_3)
    ])
  ]))
}